function cleanPrivacyPage() {
  function cleanSpaces(htmlText) {
    return htmlText.replace(/&nbsp;|\u00A0/g, ' ');
  }

  const originalSetHTML = Object.getOwnPropertyDescriptor(Element.prototype, 'innerHTML').set;
  const originalInsertHTML = Element.prototype.insertAdjacentHTML;

  Object.defineProperty(Element.prototype, 'innerHTML', {
    set: function (htmlContent) {
      if (this.closest && this.closest('.privacy-page')) {
        htmlContent = cleanSpaces(htmlContent);
      }
      originalSetHTML.call(this, htmlContent);
    }
  });

  Element.prototype.insertAdjacentHTML = function (position, htmlContent) {
    if (this.closest && this.closest('.privacy-page')) {
      htmlContent = cleanSpaces(htmlContent);
    }
    originalInsertHTML.call(this, position, htmlContent);
  };
}

const onDocumentReady = () => {
  const privacyPage = document.getElementsByClassName(".privacy-page");

  if (privacyPage) {
    cleanPrivacyPage();
  }

};

if (document.readyState !== "loading") {
  onDocumentReady();
} else {
  document.addEventListener("DOMContentLoaded", onDocumentReady);
}